const DEFAULT_MESSAGE = 'Ocorreu um erro ao realizar o pagamento. Verifique os dados e tente novamente!'
const CARD_NOT_APPROVED = 'Cartão não aprovado, por favor, tente com outro cartão.'
const TRY_ANOTHER_CARD = 'Por favor, tente com outro cartão'

export {
    DEFAULT_MESSAGE, 
    CARD_NOT_APPROVED,
    TRY_ANOTHER_CARD
}